/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarkupV2Delete
 */
export interface MarkupV2Delete {
    /**
     * 
     * @type {string}
     * @memberof MarkupV2Delete
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupV2Delete
     */
    deleted?: boolean;
}

export function MarkupV2DeleteFromJSON(json: any): MarkupV2Delete {
    return MarkupV2DeleteFromJSONTyped(json, false);
}

export function MarkupV2DeleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkupV2Delete {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
    };
}

export function MarkupV2DeleteToJSON(value?: MarkupV2Delete | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'deleted': value.deleted,
    };
}


